<template>
  <p>Nous vous conseillons d’utiliser <a href="https://www.google.com/chrome/" target="_blank" rel="noopener">Google Chrome</a>.</p>
</template>

<script>
export default {
  name: 'ModernBrowsers'
}
</script>

<style scoped lang="scss">
  .chrome::before {
    content: url('../../assets/images/general/chrome.svg');
    display: inline-block;
    width: .75em;
    padding-right: .25em;
  }
</style>
